import React, { useState } from "react";
import { trackPromise } from "react-promise-tracker";
import { useHistory } from 'react-router-dom';
import Row from "@visa/vds/row";
import Col from "@visa/vds/col";
import Form from "@visa/vds/form";
import FormControl from "@visa/vds/form-control";
import Input from "@visa/vds/input";
import Typography from "@visa/vds/typography";
import RadioGroupControl from "@visa/vds/radio-group-control";
import Radio from "@visa/vds/radio";
import ButtonGroup from "@visa/vds/button-group";
import ButtonText from "@visa/vds/button-text";
import MCSConfirmDialog from '../../../../components/MCSConfirmDialog';
import MCSReadonlyField from "../../../../components/MCSReadonlyField";
import MCSSpace from "../../../../components/MCSSpace";
import { AdminRoutes } from "../../../../_constants/PageRoutes";
import { EmailNotificationApi } from '../../../../services/emailNotification.service';
import { EmailNotificationEventType } from "_constants/EmailNotificationConstants";

const UserGroupSettings = (props) => {
    const { emailEvent, setEmailEvent, alertObj } = props;
    const history = useHistory();

    // Components states
    const [confirmDialog, setConfirmDialog] = useState(null);

    // navigation / router
    const returnToEmailNotificationPage = () => {
        history.push(AdminRoutes.EMAILNOTIFICATION);
    }

    // update emailNotificationEvent
    const udpateEmailNotificationEvent = async (id, alertObj) => {
        trackPromise(
            EmailNotificationApi.UpdateEmailNotificationEvent(emailEvent.id, emailEvent)
                .then((response) => {
                    alertObj.setSuccessMessage("Email Notification Event successfully updated.")
                    setEmailEvent(response.data);
                })
                .catch((error) => {
                    alertObj.setErrorMessage("Email Notification Event failed to be updated.");
                })
        );
    };

    const confirmSaveChanges = () => {
        let confirmMessage = "Are you sure you want to save the changes?";
        setConfirmDialog({
            ...confirmDialog,
            title: "Confirm",
            type: "warning",
            message: confirmMessage,
            open: true,
            id: "update-emailnotificationevent-confirm",
        });
    }


    return (
        <>
            {confirmDialog && (
                <MCSConfirmDialog
                    alertObj={alertObj}
                    confirmHandler={udpateEmailNotificationEvent}
                    confirmDialog={confirmDialog}
                    setConfirmDialog={setConfirmDialog}
                />
            )}
            <Row>
                <Col>
                    <MCSReadonlyField label="Description Text" text={emailEvent?.name} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form style={{ marginTop: "-12px" }}>
                        <FormControl position="left" space="fifty">
                            <Input
                                label="Email Notification for User Group"
                                name="userGroupName"
                                value={emailEvent?.userGroupName || ""}
                                onChange={(e) =>
                                    setEmailEvent({
                                        ...emailEvent,
                                        userGroupName: e.target.value,
                                    })
                                }
                            />
                        </FormControl>
                    </Form>
                </Col>
            </Row>
            <Row>
                <Col>
                    <MCSReadonlyField label="User Group Type" text={emailEvent?.userGroupTypeName} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <MCSReadonlyField label="Email Type" text={emailEvent?.emailTypeName} />
                </Col>
            </Row>
            {emailEvent.emailType == EmailNotificationEventType.Recurring && emailEvent?.frequency &&
                <Row>
                    <Col>
                        <Typography className="vss-field-label">
                            <b>Email Notification Frequency</b>
                        </Typography>
                        <Row>
                            <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                                <RadioGroupControl
                                    value={emailEvent?.frequency.toString()}
                                    legend={"Default setting for this user group."}
                                    onChange={(e) =>
                                        setEmailEvent({
                                            ...emailEvent,
                                            frequency: parseInt(e.target.value),
                                        })
                                    }
                                >
                                    <Radio name="emailEvent.frequency" value={"1"} label="Hourly" />
                                    <Radio name="emailEvent.frequency" value={"2"} label="Daily" />
                                    <Radio name="emailEvent.frequency" value={"3"} label="Weekly" />
                                </RadioGroupControl>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            }
            {emailEvent.emailType == EmailNotificationEventType.Reminder && emailEvent?.emailSchedule &&
                <Row>
                    <Col>
                        <MCSReadonlyField label="Email Notification Schedule" text={emailEvent?.emailSchedule} />
                    </Col>
                </Row>
            }
            <MCSSpace />
            <Row>
                <Col>
                    <ButtonGroup direction="right">
                        <ButtonText colorScheme="secondary" onClick={returnToEmailNotificationPage}>Cancel</ButtonText>
                        <ButtonText colorScheme="primary" onClick={confirmSaveChanges}>Save Changes</ButtonText>
                    </ButtonGroup>
                </Col>
            </Row>
        </>
    );
};

export default UserGroupSettings;
